<template>
  <div class="container">
    <form novalidate @submit.prevent="submitPincode">
      <BreadcrumbGroup v-if="!isAuWallet()" :items="breadcrumbItems" />

      <HeadingOne class="-margin-md">秘密のことば入力</HeadingOne>

      <ErrorsAlert
        :errors="errors"
        :column-only="true"
        :items="inputItemsMb"
      ></ErrorsAlert>

      <p>
        ご本人さま確認のため、ご設定いただいた質問とその答えを１つご入力ください。
      </p>

      <TableBox>
        <TableBody>
          <TableRow>
            <TableHeader>質問</TableHeader>
            <TableData :has-error="errors['secret_word_ask']">
              <InputGroup :errors="errors" :prop-names="['secret_word_ask']">
                <BtnSelect
                  id="secret_word_ask1"
                  v-model="secretQuestions.secret_word_ask"
                  class="form-control"
                >
                  <option
                    v-for="(secretWordAsk, index) in selectedSecretWordAsks"
                    :key="'secretWordAsk1' + index + 1"
                    :value="secretWordAsk['value']"
                  >
                    {{ secretWordAsk["name"] }}
                  </option>
                </BtnSelect>
              </InputGroup>
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader
              >質問の答え<small class="moji"
                >【全角ひらがな、30文字以内】</small
              ></TableHeader
            >
            <TableData :has-error="errors['secret_word_ans']">
              <InputGroup :errors="errors" :prop-names="['secret_word_ans']">
                <InputgroupAppend>
                  <InputItem
                    v-model="secretQuestions.secret_word_ans"
                    class="-lg"
                    :maxlength="30"
                  ></InputItem>
                </InputgroupAppend>
              </InputGroup>
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" @click.prevent="submitPincode"> 次へ </BtnMain>
      </BtngroupSingle>

      <ListGroup v-if="!isAuWallet()" class="-link _mb-sm-60 _mb-md-120">
        <ListItem class="-link" router-name="sv036" target="_blank"
          >秘密のことばを忘れた方はこちら</ListItem
        >
      </ListGroup>
    </form>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  checkSecretWordLambdaInvoke,
  getSecretWordKeysLambdaInvoke,
} from "@/utils/LambdaHelper";
import { secretWordAsks, inputItemsMb } from "@/constants/constant";
import { isAuWallet } from "@/utils/UserAgent";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage, scrollTop } from "@/utils/Other";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtnSelect from "@/components/button/BtnSelect";
import InputGroup from "@/components/input/InputGroup";
import InputItem from "@/components/input/InputItem";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import InputgroupAppend from "@/components/input/InputgroupAppend";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb031",
  components: {
    InputgroupAppend,
    ListItem,
    ListGroup,
    InputItem,
    InputGroup,
    BtnSelect,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    BtnMain,
    BtngroupSingle,
    HeadingOne,
    ErrorsAlert,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "秘密のことば入力",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "秘密のことば入力",
          active: true,
        },
      ],
      secretWordKeys: [],
      secretWordAsks: secretWordAsks,
      errors: {},
      isDisabled: false,
      secretQuestions: {
        secret_word_ask: "00",
        secret_word_ans: "",
      },
      inputItemsMb: inputItemsMb,
    };
  },
  computed: {
    selectedSecretWordAsks() {
      let asks = [];
      for (let ask of this.secretWordAsks) {
        if (ask.value === "00" || this.secretWordKeys.indexOf(ask.value) > -1) {
          asks.push(ask);
        }
      }
      return asks;
    },
  },
  mounted() {
    try {
      getSecretWordKeysLambdaInvoke()
        .then((res) => {
          let resBody = JSON.parse(res.body);
          this.secretWordKeys = resBody.secret_word_keys || [];
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitPincode: function () {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};

        initCredentials()
          .then(() => {
            checkSecretWordLambdaInvoke(this.secretQuestions)
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "mb034" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    isAuWallet: function () {
      return isAuWallet();
    },
  },
};
</script>

<style scoped></style>
